import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

type VideoResolution = {
  height: number;
  width: number;
};

const validateMaxResolution = (
  allow4k: boolean,
  resolution: VideoResolution | undefined,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): { resolutionHeight: number; resolutionWidth: number } => {
  if (resolution) {
    const { height, width } = resolution;

    console.log(`Resolution: ${width} x ${height}`);

    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_RESOLUTION_WIDTH] = width;
    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_RESOLUTION_HEIGHT] = height;

    if (!allow4k && height > 1080) {
      addError(VALIDATIONS.MAX_RESOLUTION);
    }

    if (allow4k && height > 2160) {
      addError(VALIDATIONS.MAX_RESOLUTION_4K);
    }

    return {
      resolutionHeight: height,
      resolutionWidth: width,
    };
  }
  return {
    resolutionHeight: 0,
    resolutionWidth: 0,
  };
};

export default validateMaxResolution;
